module.exports = __webpack_public_path__ + "static/forbes-a5d9edb664071781e5dbb21b24632d55.png";